import { render, staticRenderFns } from "./CierreUniversales.vue?vue&type=template&id=b0b39cb6&"
import script from "./CierreUniversales.vue?vue&type=script&lang=js&"
export * from "./CierreUniversales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports